import React from 'react';
import TextareaAutosizeDep from 'react-textarea-autosize';

const TextareaAutosize = (props) => (
  <div className="textarea-autosize-wrapper" style={{ position: 'relative', width: '100%' }}>
    <TextareaAutosizeDep {...props} />
  </div>
);

export default TextareaAutosize;
